import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import { manualChange } from "./index";

export const useProcessExecution = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({ manualChange: manualChange(customFetch) }),
    [customFetch]
  );
};
